import './auth.css';
import React, { Component } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { login, signup, initForm, setModoTela, esqueciSenha, redefinirsenha, buscarImagemLogin } from './authActions';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import If from '../common/operator/if';
import Messages from '../common/msg/messages';
import Input from '../common/form/inputAuth';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { ThemeProvider } from '@material-ui/styles';
import imagemLogo from '../assets/images/logo_branca_vermelha.png';
import imagemLogin from '../assets/images/imagem_login.jpeg';
import imagemLogoInfinitum from '../assets/images/logo_infinitum_vertical_branca.png';
import consts from '../consts';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

class Auth extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginMode: true,
			windowWidth: window.innerWidth,
			mostrarSenha: false
		};
	}

	componentDidMount() {
		this.handleResize = () => {
			this.setState({ windowWidth: window.innerWidth });
		};
		window.addEventListener('resize', this.handleResize);
	}

	componentWillMount() {
		this.props.buscarImagemLogin();
	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	onSubmit(values) {
		const { login, signup } = this.props;
		this.state.loginMode ? login(values) : signup(values);
	}

	getStyles() {
		return makeStyles((theme) => ({
			paper: {
				marginTop: theme.spacing(8),
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			},
			avatar: {
				margin: theme.spacing(1),
				backgroundColor: theme.palette.secondary.main
			},
			form: {
				width: '100%',
				marginTop: theme.spacing(1),
			},
			submit: {
				margin: theme.spacing(3, 0, 2),
			},
		}));
	}

	getTheme() {

		return createMuiTheme({
			palette: {
				primary: {
					// light: '#ffffff',
					main: '#ffffff',
					// dark: '#ffffff',
					// contrastText: será calculada para contrastar com palette.primary.main
				},
				secondary: {
					// light: '#0066ff',
					main: '#ca2d28',
					// dark: será calculada com base palette.secondary.main,
					// contrastText: '#ffcc00',
				},
				// Usado por `getContrastText()` para maximizar o contraste entre
				// o plano de fundo e o texto.
				contrastThreshold: 3,
				// Usado pelas funções abaixo para mudança de uma cor de luminância por aproximadamente
				// dois índices dentro de sua paleta tonal.
				// Por exemplo, mude de Red 500 para Red 300 ou Red 700.
				tonalOffset: 0.2,
			},
		});
	}

	render() {

		const classes = this.getStyles();

		const { loginMode } = this.state;
		const { handleSubmit } = this.props;

		return (
			<ThemeProvider theme={this.getTheme()}>
				<div style={{ backgroundColor: '#1f3269', height: '100%' }}>
					<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundSize: 'cover' }}>

						<CssBaseline />

						<Row alignCenter style={{ width: '100%', height: '100%' }}>
							<Grid cols='12 12 6 4'
								style={{ 
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center'
								}}>
								<div className={classes.paper}
									style={{
										width: '100%',
										paddingLeft: 16,
										paddingRight: 16,
										textAlign: 'center'										
									}}>
									<img src={imagemLogo} style={{ width: 320, marginBottom: 40 }} />

									{/* <h1 style={{ fontSize: 32, color: '#ffffff', marginBottom: 20 }}>Portal Infinitum</h1> */}

									{this.props.modoTela == 'login' &&
										<div>
											<form className={classes.form} noValidate onSubmit={handleSubmit(v => this.onSubmit(v))}>

												<label htmlFor='login' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Usuário</label>
												<input
													className='form-control'
													placeholder={'Informe seu usuário'}
													type='text'
													value={this.props.formularioValues ? this.props.formularioValues.login : ''}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															login: (e.target.value || '').toLowerCase()
														});
													})} />

												<label htmlFor='senha' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Senha</label>
												<div style={{ position: 'relative' }}>
													<input
														className='form-control'
														placeholder='Informe sua senha'
														type={this.state.mostrarSenha ? 'text' : 'password'}
														value={
															this.props.formularioValues
																? this.props.formularioValues.senha
																: ''
														}
														onChange={e => {
															this.props.initForm({
																...this.props.formularioValues,
																senha: (e.target.value || '').trim()
															});
														}}
														style={{
															paddingRight: 42
														}}
													/>

													<button
														type='button'
														onClick={() => {
															this.setState({
																mostrarSenha: !this.state.mostrarSenha
															});
														}}
														style={{
															position: 'absolute',
															right: 8,
															top: '50%',
															transform: 'translateY(-50%)',
															border: 'none',
															background: 'transparent',
															padding: 5,
															cursor: 'pointer',
															color: '#666',
															outline: 'none'
														}}
														title={
															this.state.mostrarSenha
																? 'Ocultar senha'
																: 'Visualizar senha'
														}
													>
														<i
															className={
																this.state.mostrarSenha
																	? 'fas fa-eye-slash'
																	: 'fas fa-eye'
															}
														/>
													</button>
												</div>

												<Button
													style={{ marginTop: 40 }}
													type="submit"
													fullWidth
													variant="contained"
													color="secondary"
													className={classes.submit} >
													Entrar
												</Button>
											</form>

											<div style={{ textAlign: 'center', marginTop: 20 }}>
												<a href='#' style={{ color: '#ffffff', marginLeft: 8, fontSize: 16, textDecoration: 'underline' }} onClick={() => this.props.setModoTela('esqueciSenha')}>Esqueci minha senha</a>
											</div>
										</div>}

									{this.props.modoTela == 'esqueciSenha' &&
										<div>
											<form className={classes.form} noValidate onSubmit={handleSubmit(v => this.props.esqueciSenha(v))}>

												<label htmlFor='login' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Usuário</label>
												<input
													className='form-control'
													placeholder={'Informe seu e-mail'}
													type='text'
													value={this.props.formularioValues ? this.props.formularioValues.login : ''}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															login: (e.target.value || '').toLowerCase()
														});
													})} />

												<Button
													style={{ marginTop: 40 }}
													type="submit"
													fullWidth
													variant="contained"
													color="secondary"
													className={classes.submit} >
													Receber Código
												</Button>

												<div style={{ textAlign: 'center', marginTop: 20 }}>
													<a href='#' style={{ color: '#ffffff', marginLeft: 8, fontSize: 16, textDecoration: 'underline' }} onClick={() => this.props.setModoTela('login')}>Voltar para tela de login</a>
												</div>
											</form>
										</div>}

									{this.props.modoTela == 'redefinirSenha' &&
										<div>
											<form className={classes.form} noValidate onSubmit={handleSubmit(v => this.props.redefinirsenha(v))}>

												<label htmlFor='login' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Usuário</label>
												<input
													className='form-control'
													placeholder={'Informe seu e-mail'}
													type='text'
													value={this.props.formularioValues ? this.props.formularioValues.login : ''}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															login: (e.target.value || '').toLowerCase()
														});
													})} />

												<label htmlFor='senha' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Senha</label>
												<input
													className='form-control'
													placeholder={'Informe sua senha'}
													type='password'
													value={this.props.formularioValues ? this.props.formularioValues.senha : ''}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															senha: (e.target.value || '').trim()
														});
													})} />

												<label htmlFor='senha_confirmacao' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Confirme sua Senha</label>
												<input
													className='form-control'
													placeholder={'Informe sua senha'}
													type='password'
													value={this.props.formularioValues ? this.props.formularioValues.senha_confirmacao : ''}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															senha_confirmacao: (e.target.value || '').trim()
														});
													})} />

												<label htmlFor='codigo' style={{ color: '#ffffff', textAlign: 'left', width: '100%', marginTop: 20 }}>Código</label>
												<input
													className='form-control'
													placeholder={'Informe o código de confirmação'}
													type='numeric'
													value={this.props.formularioValues ? this.props.formularioValues.codigo : ''}
													onChange={(e => {
														this.props.initForm({
															...this.props.formularioValues,
															codigo: (e.target.value || '').trim()
														});
													})} />

												<Button
													style={{ marginTop: 40 }}
													type="submit"
													fullWidth
													variant="contained"
													color="secondary"
													className={classes.submit} >
													Redefinir Senha
												</Button>

												<div style={{ textAlign: 'center', marginTop: 20 }}>
													<a href='#' style={{ color: '#ffffff', marginLeft: 8, fontSize: 16, textDecoration: 'underline' }} onClick={() => this.props.setModoTela('login')}>Voltar para tela de login</a>
												</div>
											</form>
										</div>}

									<img src={imagemLogoInfinitum} style={{ width: 150, marginTop: 20 }} />

									<Snackbar
										open={this.props.message.open}>
										<MuiAlert severity={this.props.message.type} variant="filled">
											{this.props.message.text}
										</MuiAlert>
									</Snackbar>
									
								</div>								
							</Grid>
							
							{this.state.windowWidth >= 768 &&
							<Grid cols='12 12 6 8' style={{ backgroundColor: '#1f3269', padding: 0, margin: 0 }}>
								<img src={this.props.imagemLogin} 
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										display: 'block'
									}}/>
							</Grid>}
						</Row>
					</div>
				</div>
			</ThemeProvider>
		);
	}
}

Auth = reduxForm({ form: 'authForm' })(Auth);
const mapStateToProps = state => ({
	message: state.auth.message,
	modoTela: state.auth.modoTela,
	imagemLogin: state.auth.imagemLogin,
	formularioValues: getFormValues('authForm')(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({ login, signup, initForm, setModoTela, esqueciSenha, redefinirsenha, buscarImagemLogin }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Auth);
